import { Link } from "gatsby";
import React from "react";
import * as style from "./style.module.css";
import json from "/src/siteData.json";
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

const phoneNumber = json.footer.phoneNumber;

const Component = () => {
  const data = json.footer;

  return (
    <div className={style.container}>
      <p className={style.txt}>
        入塾・授業内容についてのご相談は下記番号からお待ちしております
      </p>
      <div className={`flex_x ${style.innerWrap}`}>
        <div className={style.link_totuka}>
          <a className={style.tel} href="tel:045-870-1612">
            <p>戸塚校</p>
            <div className={style.number}>
              <FontAwesomeIcon icon={faPhone} />
              <span>045-870-1612</span>
            </div>
          </a>
        </div>
        
      </div>
    </div>
  );
};

export default Component;
